/**
 * קובץ קוד של מסך שלא נטען (02/11/2026) — בלי תלויות, כי ErrorBoundary קורא
 * לזה ברגע שמשהו כבר נשבר.
 *
 * ⚠ אחרי עדכון גרסה הקבצים הישנים נמחקים מהשרת, ולשונית שנפתחה לפני העדכון
 * מבקשת קובץ שכבר אינו קיים. אלה הניסוחים של Chrome, Safari ו-Firefox, ושל
 * טעינת ה-CSS של Vite.
 */
const CHUNK_RE = /dynamically imported module|Importing a module script failed|error loading dynamically imported|Unable to preload CSS|ChunkLoadError/i;

export class ChunkLoadError extends Error {
  override name = 'ChunkLoadError';
}

export function markChunkError(err: unknown): Error {
  const msg = err instanceof Error ? err.message : String(err);
  return CHUNK_RE.test(msg) ? new ChunkLoadError(msg) : (err instanceof Error ? err : new Error(msg));
}

/** האם השגיאה היא קובץ קוד שלא נטען (גרסה התחלפה / הרשת נפלה באמצע). */
export function isChunkLoadError(err: unknown): boolean {
  if (!err) return false;
  if (err instanceof ChunkLoadError) return true;
  const e = err as { name?: string; message?: string };
  return e.name === 'ChunkLoadError' || CHUNK_RE.test(e.message ?? '');
}
